export const ORDER_STATUSES = ['Packed', 'Shipped complete', 'delivered', 'Pick complete'];